export enum ActionsEnum {
    Desconsiderar = 0,
    Visualizar = 13,
    Cancelar = 30,
    Cadastrar = 14,
    Editar = 15,
    Remover = 16,
    Habilitar = 17,
    Desabilitar = 18,
    ImportarCSV = 19,
    ReenviarEvento = 20,
    DownloadTrilha = 21,
    DownloadTodasTrilhas = 22,
    DownloadDossie = 23,
    DesbloquearProtocolo = 24,
    AcaoComercial = 25,
    ContatoHistoricoComercial = 26,
    SalvarContatoComercial = 27,
    Exportar = 28,
    DownloadCertificado = 29,
    GerarProtocolo = 31,
    CadastrarProdutoCatalogo = 38,
    ClonarCatalogo = 39,
    ClonarProduto = 40,
}
